(function () {
  'use strict';

  class ShopifyDataLayerTracker {
    constructor(context) {
      this.context = context;
      this.pageType = context.page.template;
      this.cart = context.cart;
      this.currency = context.currency;
      this.lastCheckout = 0;
      window.dataLayer = window.dataLayer || [];

      document.addEventListener('bb-legacy:cart-added', event => this.onCartAdded(event.detail));
      document.addEventListener('bb-legacy:cart-updated', event => {
        this.cart = event.detail;
        this.currency = event.detail.currency || this.currency;
      });
      document.addEventListener('submit', event => this.onSubmit(event));
      document.addEventListener('click', event => this.onClick(event));
      window.addEventListener('pageshow', () => { this.lastCheckout = 0; });
      this.trackPage();
    }

    emit(name, ecommerce) {
      // Clear previous ecommerce fields before GTM merges this event's payload.
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: name,
        event_id: name + '_' + (window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID() : Date.now() + '_' + Math.random()),
        page_type: this.pageType,
        ecommerce: Object.assign({ currency: this.currency }, ecommerce)
      });
    }

    item(line) {
      return {
        item_id: String(line.variant_id || line.id),
        item_name: line.product_title || line.title,
        item_brand: line.vendor || null,
        item_category: line.product_type || line.type || null,
        item_variant: line.variant_title || null,
        price: (line.final_price == null ? line.price : line.final_price) / 100,
        quantity: line.quantity || 1
      };
    }

    collectionItem(product) {
      return Object.assign(this.item({
        variant_id: product.variant.id,
        product_title: product.title,
        vendor: product.vendor,
        type: product.type,
        variant_title: product.variant.title,
        price: product.variant.price
      }), { index: product.position });
    }

    trackPage() {
      const product = this.context.product;
      const collection = this.context.collection;
      if (this.pageType === 'product' && product) {
        const variant = product.variants.find(item => item.id === product.selected_variant_id) || product.variants[0];
        if (!variant) return;
        this.emit('view_item', {
          value: variant.price / 100,
          items: [this.item({
            variant_id: variant.id, product_title: product.title, vendor: product.vendor,
            type: product.type, variant_title: variant.title, price: variant.price
          })]
        });
      } else if (this.pageType === 'collection' && collection) {
        this.emit('view_item_list', { items: collection.products.map(item => this.collectionItem(item)) });
      } else if (this.pageType === 'cart' && this.cart) {
        this.emit('view_cart', this.cartPayload());
      }
    }

    onCartAdded(detail) {
      const line = detail && detail.item;
      const quantity = Number(detail && detail.quantity);
      if (!line || line.errors || line.status || !(line.variant_id || line.id) ||
          !Number.isFinite(line.price) || !Number.isFinite(quantity) || quantity <= 0) return;
      // Shopify returns the total line quantity, so use the submitted quantity for the event.
      const item = Object.assign(this.item(line), { quantity });
      this.emit('add_to_cart', { value: item.price * quantity, items: [item] });
      if (this.cart) {
        const existing = this.cart.items.find(item => item.key && item.key === line.key);
        const previousValue = existing ? this.item(existing).price * existing.quantity * 100 : 0;
        this.cart.total_price += item.price * line.quantity * 100 - previousValue;
        if (existing) Object.assign(existing, line);
        else this.cart.items.push(Object.assign({}, line));
      }
    }

    cartPayload() {
      return { value: this.cart.total_price / 100, items: this.cart.items.map(item => this.item(item)) };
    }

    beginCheckout() {
      if (!this.cart || !this.cart.items.length) return;
      const now = Date.now();
      if (now - this.lastCheckout < 1000) return;
      this.lastCheckout = now;
      this.emit('begin_checkout', this.cartPayload());
    }

    onSubmit(event) {
      if (event.defaultPrevented) return;
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const path = new URL(form.action, location.href).pathname;
      const submitter = event.submitter || document.activeElement;
      if (/\/checkout\/?$/.test(path) ||
          (/\/cart\/?$/.test(path) && submitter && submitter.name === 'checkout')) {
        this.beginCheckout();
      }
    }

    onClick(event) {
      if (event.defaultPrevented || !(event.target instanceof Element)) return;
      const link = event.target.closest('a[href]');
      if (!link) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      if (/\/checkout\/?$/.test(url.pathname)) this.beginCheckout();
      const collection = this.context.collection;
      if (!collection) return;
      const match = url.pathname.match(/\/products\/([^/]+)/);
      if (!match) return;
      let handle;
      try { handle = decodeURIComponent(match[1]); } catch (error) { return; }
      const product = collection.products.find(item => item.handle === handle);
      if (product) this.emit('select_item', { items: [this.collectionItem(product)] });
    }
  }

  function initialize() {
    if (window.ShopifyDL || !window.__SHOPIFY_CONTEXT__) return;
    window.ShopifyDL = new ShopifyDataLayerTracker(window.__SHOPIFY_CONTEXT__);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
